import { create, useStore } from 'zustand';
import createFavoriteVehiclesSlice from './favoriteVehiclesSlice';
import createFbsSlice from './fbsSlice';
import createHomeBaseSlice from './homebaseSlice';
import createRecentSearchesSlice from './recentSearchesSlice';
import createRecentlyViewedVehiclesSlice from './recentlyViewedVehiclesSlice';
import createRecommendedVehiclesSlice from './recommendedVehiclesSlice';
import { IAppState } from './stateTypes';
import createUserSlice from './userSlice';
import createTestSlice from './testSlice';
import createQuickLinksSlice from './quickLinksSlice';

export const appState = create<IAppState>()((...a) => ({
    ...createFavoriteVehiclesSlice(...a),
    ...createFbsSlice(...a),
    ...createHomeBaseSlice(...a),
    ...createRecentlyViewedVehiclesSlice(...a),
    ...createRecentSearchesSlice(...a),
    ...createRecommendedVehiclesSlice(...a),
    ...createQuickLinksSlice(...a),
    ...createTestSlice(...a),
    ...createUserSlice(...a),
}));

const useAppState = <T>(selector: (state: IAppState) => T): T => useStore(appState, selector);

export default useAppState;

// @ts-expect-error it's appstate, I don't want to define it on the window
window.appState = appState;
